import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { NotFoundPage } from '@/pages/not-found';
import { useMetaPixelPageView } from '@/shared/analytics/use-meta-pixel-page-view';
import type { AppRouterContext } from '@/router-context';

const RootComponent = () => {
  useMetaPixelPageView();

  return (
    <>
      <Outlet />
      {import.meta.env.VITE_PUBLIC_APP_ENV === 'prod' && (
        <TanStackRouterDevtools position="bottom-right" initialIsOpen={false} />
      )}
    </>
  );
};

export const Route = createRootRouteWithContext<AppRouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
});
